import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewClarificationFieldModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewClarificationFieldModal: React.FC<ViewClarificationFieldModalProps> = ({ open, onClose }) => {
  const { selectedField, loading } = useAppSelector((state) => state.clarificationFields);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Campo de Clarificación</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedField ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Campo
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.field}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Etiqueta
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.label}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Prioridad
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.priority}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Ejemplos
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.examples.join(', ')}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Comportamiento por Defecto
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.defaultBehavior}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Aplicable A
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.applicableTo.join(', ')}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Dynamic Options
              </Typography>
              <Box
                component="pre"
                sx={{
                  mb: 2,
                  p: 1.5,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 1,
                  overflow: 'auto',
                  fontSize: '0.85rem',
                  fontFamily: 'monospace',
                  maxHeight: 200,
                }}
              >
                {selectedField.dynamicOptions
                  ? JSON.stringify(selectedField.dynamicOptions, null, 2)
                  : '(vacío)'}
              </Box>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Stage
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.stage}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Value Map
              </Typography>
              <Box
                component="pre"
                sx={{
                  mb: 2,
                  p: 1.5,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 1,
                  overflow: 'auto',
                  fontSize: '0.85rem',
                  fontFamily: 'monospace',
                  maxHeight: 200,
                }}
              >
                {selectedField.valueMap
                  ? JSON.stringify(selectedField.valueMap, null, 2)
                  : '(vacío)'}
              </Box>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Include In Query
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.includeInQuery ? 'Sí' : 'No'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado Por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.createdBy || '(N/A)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedField.updatedAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado Por
              </Typography>
              <Typography variant="body1">
                {selectedField.updatedBy || '(N/A)'}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay campo seleccionado</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewClarificationFieldModal;
